<template>
  <modal size="xl" :title="detail.ProviderName + ' Detail'">
    <template #content>
      <apexChart
        :data="getDatasets()"
        :height="237"
        :chartOptions="chartOptions"
      ></apexChart>
    </template>
  </modal>
</template>

<script>
import apexChart from "./../../../components/apexChart.vue";
export default {
  name: "detail",
  props: ["detail"],
  components: { apexChart },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "bar",
          stacked: true,
          height: 600,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              total: {
                enabled: true,
                offsetX: 0,
                style: {
                  fontSize: "13px",
                  fontWeight: 900,
                },
              },
            },
          },
        },
        xaxis: {
          categories: [],
        },
        fill: {
          colors: ["#55ce63", "#ffb22b", "#fc4b6c", "#6c757d"],
        },
      },
    };
  },
  methods: {
    getDatasets() {
      var news = [];
      var changed = [];
      var cancelled = [];
      var other = [];
      //   var total = [];
      let xAxis = [];
      this.detail.Dates.forEach((element) => {
        xAxis.push(this.$moment(new Date(element.Date)).format("DD.MM.YY"));
        news.push(element.New);
        changed.push(element.Changed);
        cancelled.push(element.Cancelled);
        other.push(element.Other);
        // total.push(element.Total);
      });
      this.chartOptions.xaxis.categories = xAxis;
      return [
        {
          name: "New",
          data: news,
          color: "#55ce63",
        },
        {
          name: "Changed",
          data: changed,
          color: "#ffb22b",
        },
        {
          name: "Cancelled",
          data: cancelled,
          color: "#fc4b6c",
        },
        {
          name: "Other",
          data: other,
          color: "#6c757d",
        },
      ];
    },
  },
};
</script>

<style></style>
